import types from './types';

const defaultState = {
	selfDownloadedThumbnails: [],
  isLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
		case types.DOWNLOAD_FILE:
		case types.DOWNLOAD_FILE_AS_BA:
			return { ...state, filePreview: !params.thumbnail ? null : state.filePreview, isLoading: true };
		case types.DOWNLOAD_FILE_SUCCESS:
		case types.DOWNLOAD_FILE_AS_BA_SUCCESS:
			if (request.params.thumbnail)
				return { ...state, selfDownloadedThumbnails: {...state.selfDownloadedThumbnails, [request.params.fileId]: data}, isLoading: false };
			else
				return { ...state, filePreview: data, isLoading: false };
		case types.DOWNLOAD_FILE_FAILURE:
		case types.DOWNLOAD_FILE_AS_BA_FAILURE:
			return { ...state, isLoading: false };

    default:
      return state;
  }
};
